"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
import PasswordInput from "@/views/accountItems/components/PasswordInput.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import { AccountSessionMixins } from "@/service/account-session";
import RSAEncryptUtil from "@/configuration/rsa";
import UiForm, {
  UiFormAnnotations,
  UiFormController
} from "@/components/form/UiForm.vue";
import i18n from "@/lang";
import API from "@ym-framework/api-utils";
export class Accountpassword extends UiFormController {
  constructor() {
    super(...arguments);
    this.old_password = "";
    this.new_password = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "accounteditpassword.the_original_password_cannot_be_empty"
      ),
      trigger: "blur"
    }
  ])
], Accountpassword.prototype, "old_password", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "accounteditpassword.the_new_password_cannot_be_empty"
      ),
      trigger: "blur"
    },
    {
      validator: (rule, value, callback) => {
        if (value !== null && value !== void 0 && value !== "") {
          let runoob = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,24}$/;
          let message = rule.hasOwnProperty("message") ? rule.message : i18n.t("accounteditpassword.incorrect_password_format");
          let search = value.search(runoob);
          if (value !== "" && search < 0) {
            callback(message);
            return false;
          }
        }
        callback();
        return true;
      },
      message: i18n.t(
        "accounteditpassword.incorrect_password_format"
      ),
      trigger: "blur"
    }
  ])
], Accountpassword.prototype, "new_password", 2);
let EditPasswordDialog = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.rsaEncrypt = new RSAEncryptUtil();
    this.passwordaccount = new Accountpassword();
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  open() {
    return __async(this, null, function* () {
      this._edit_password_dialog.show();
    });
  }
  editPassword() {
    return __async(this, null, function* () {
      try {
        if (this.$session.marks.is("SECURITY_TRANSFER")) {
          const submitData = {
            new_password: this.passwordaccount.new_password,
            password: this.passwordaccount.old_password,
            platform: "web"
          };
          const entry_data = this.rsaEncrypt.encrypt(submitData);
          if (entry_data.flag === true) {
            const requestData = {
              encrypted_data: entry_data.data
            };
            yield API.put(
              "api://base.auth/api/v7/accounts/changepassword",
              requestData
            );
          } else {
            yield API.put("api://base.auth/api/v7/accounts/changepassword", {
              new_password: this.passwordaccount.new_password,
              password: this.passwordaccount.old_password,
              platform: "web"
            });
          }
        } else {
          const response = yield API.put(
            "api://base.auth/api/v7/accounts/changepassword",
            {
              new_password: this.passwordaccount.new_password,
              password: this.passwordaccount.old_password,
              platform: "web"
            }
          );
        }
        this.$message.success(
          this.$t(
            "accounteditpassword.the_modification_was_successful_please_log_in_again_"
          )
        );
        this.$router.push("/logout");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  toForgetPassword() {
    return __async(this, null, function* () {
      window.open("https://app.kuajingvs.com/forgetpassword", "_blank");
    });
  }
};
__decorateClass([
  Ref("edit-password-dialog")
], EditPasswordDialog.prototype, "_edit_password_dialog", 2);
EditPasswordDialog = __decorateClass([
  Component({
    components: {
      UiDialog,
      UiForm,
      PasswordInput,
      UiSubmit
    }
  })
], EditPasswordDialog);
export {
  EditPasswordDialog as default
};
